import React, { useState } from 'react';
import componentStyles from './passwordReset.module.css';
import globalStyles from '../globals.module.css';
import NotificationModel from '../../model/notificationModel';
import { 
    NOTIFICATIONS_SUCCESS, 
    NOTIFICATIONS_ERROR, 
    EVENT_NOTIFICATION_PUSH,
    EVENT_UPDATE_ACTION_BAR_VIEW
} from '../../utils/constants';
import eventBus from '../../service/eventBus';
import { requestPasswordReset } from '../../service/userService';
import AnalyticsService from '../../service/analyticsService';
import { EVENT_PASSWORD_RESET_REQUESTED } from '../../utils/analyticsConstants';
import PageView from '../common/pageView';

const PasswordResetRequest = () => {
    const [email, setEmail] = useState('');
    const [isLoading, setIsLoading] = useState(false);

    const handleSubmit = async (e) => {
        e.preventDefault();
        setIsLoading(true);

        try {
            const response = await requestPasswordReset(email);
            const { data } = response;

            if (data.success) {
                AnalyticsService.getInstance().track(EVENT_PASSWORD_RESET_REQUESTED);
                eventBus.emit(EVENT_NOTIFICATION_PUSH, 
                    new NotificationModel(
                        'If an account exists with this email, you will receive password reset instructions shortly.',
                        NOTIFICATIONS_SUCCESS
                    )
                );
                
                // Navigate back to login after a short delay
                setTimeout(() => {
                    eventBus.emit(EVENT_UPDATE_ACTION_BAR_VIEW, 'login');
                }, 2000);
            } else {
                eventBus.emit(EVENT_NOTIFICATION_PUSH, 
                    new NotificationModel(data.error || 'An error occurred. Please try again later.', NOTIFICATIONS_ERROR)
                );
            }
        } catch (error) {
            eventBus.emit(EVENT_NOTIFICATION_PUSH, 
                new NotificationModel('An error occurred. Please try again later.', NOTIFICATIONS_ERROR)
            );
            console.error('Password reset request error:', error);
        } finally {
            setIsLoading(false);
        }
    };

    const handleBackToLogin = () => {
        eventBus.emit(EVENT_UPDATE_ACTION_BAR_VIEW, 'login');
    };

    return (
        <PageView title="Password Recovery" contentClassName={componentStyles.resetContainer}>
            <section className={`${globalStyles.standardSection} ${componentStyles.resetCard}`}>
                <div className={componentStyles.panelLabel}>Account security // reset request</div>
                <p className={componentStyles.resetDescription}>
                    Enter your email address and we'll send you instructions to reset your password.
                </p>
                
                <form onSubmit={handleSubmit} className={globalStyles.form}>
                    <div className={globalStyles.formGroup}>
                        <label>Email</label>
                        <input
                            type="email"
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                            placeholder="Enter your email"
                            required
                            className={globalStyles.standardInput}
                        />
                    </div>
                    
                    <button 
                        type="submit" 
                        className={globalStyles.primaryButton}
                        disabled={isLoading}
                    >
                        {isLoading ? 'Sending...' : 'Send Reset Link'}
                    </button>
                </form>

                <div className={componentStyles.loginPrompt}>
                    <p>Remember your password?</p>
                    <button 
                        onClick={handleBackToLogin}
                        className={globalStyles.secondaryButton}
                    >
                        Back to Login
                    </button>
                </div>
            </section>
        </PageView>
    );
};

export default PasswordResetRequest;
